import { render, staticRenderFns } from "./RegisterInvite.vue?vue&type=template&id=bece4598"
import script from "./RegisterInvite.vue?vue&type=script&lang=js"
export * from "./RegisterInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports